/**
 * Market Monitor widget registry — single page-scoped instance.
 *
 * Constructed via the shared createWidgetRegistry() factory. Registrations
 * happen in src/features/market-monitor/widgets/index.ts at module load time.
 */

import { createWidgetRegistry } from '../../../components/grid-dashboard';

export const marketMonitorWidgetRegistry = createWidgetRegistry();
